import React, { useEffect } from 'react';
import { JobPreferenceGrid } from './JobPreferencesGrid/JobPreferenceGrid';
import { PassportPreCheckPreferenceGrid } from './PassportPreCheckPreferences/PassportPreCheckGrid';
import { useDispatch, useSelector } from 'react-redux';
import { candidateDetailsSelection } from '../../Profile/CandidateDetails.selector';
import { ff_candidate_ui_passport_precheck_preferences } from 'app/constants/FeatureFlags/Candidate/Keys';
import { useDecision } from '@optimizely/react-sdk';
import { BrandType } from '@AMIEWEB/Notification/MultiChannel/Email/EmailSignature';
import { passportPreCheckPreferencesActions } from './PassportPreCheckPreferences/store/PassportPreCheckPreferences.redux';

export const OrderPreferences = () => {
  const dispatch = useDispatch();
  const { brandId, travelerId } = useSelector(candidateDetailsSelection);
  const [enablePassportPreCheckPreferences] = useDecision(ff_candidate_ui_passport_precheck_preferences);

  useEffect(() => {
    if (
      enablePassportPreCheckPreferences?.enabled &&
      (brandId === BrandType.amnNurse || brandId === BrandType.amnAllied) &&
      !!travelerId
    ) {
      dispatch(passportPreCheckPreferencesActions.getPassportPreCheckPreferencesAction({ travelerId: travelerId }));
    }

    return () => {
      dispatch(passportPreCheckPreferencesActions.reset());
    };
  }, [travelerId]);

  return (
    <React.Fragment>
      {enablePassportPreCheckPreferences?.enabled &&
        (brandId === BrandType.amnNurse || brandId === BrandType.amnAllied) && (
          <div style={{ padding: '3px 0px 30px 0px' }}>
            <PassportPreCheckPreferenceGrid />
          </div>
        )}
      <JobPreferenceGrid />
    </React.Fragment>
  );
};
